import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractComponent} from "../../abstract.component";
import {Lookups, UserEvent} from "@model";
import {UserEventGridItemType} from "../user-event-grid-item/user-event-grid-item.component";

@Component({
  selector: 'app-user-event-grid-list',
  templateUrl: './user-event-grid-list.component.html',
  styleUrl: './user-event-grid-list.component.scss',
  standalone: false
})
export class UserEventGridListComponent extends AbstractComponent {
  @Input() userEvents: UserEvent[] = [];
  @Input({required: true}) languages: Lookups[] = [];
  @Input() type: UserEventGridItemType = UserEventGridItemType.UPCOMING;
  @Input() rightButtonKey: string = '';
  @Input() leftButtonKey: string = '';
  @Input() showLeftActionButton: boolean = true;
  @Input() showRightActionButton: boolean = true;
  @Output() scrolled: EventEmitter<void> = new EventEmitter<void>();
  @Output() onLeftButtonClickCallback: EventEmitter<UserEvent> = new EventEmitter<UserEvent>();
  @Output() onRightButtonClickCallback: EventEmitter<UserEvent> = new EventEmitter<UserEvent>();


  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
